export const planetChartData = {
  type: 'horizontalBar',
  data: {
    labels: ['Enero', 'Febrero', 'Marzo'],
    datasets: [

      { // one line graph
        label: "PTI's por tipo de clínica ",
        data: [15, 24, 21],
        backgroundColor: [
          'rgb(24, 93, 160)',
          'rgb(119, 178, 235)',
          'rgb(144, 192, 239)',
          'rgb(169, 206, 242)',
          'rgb(27, 107, 185)',
          'rgb(31, 122, 210)',
          'rgb(45, 136, 224)',
          'rgb(70, 150, 228)',
          'rgb(95, 164, 231)',
        ],
        borderColor: [
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
        ],
        borderWidth: 3
      }
    ]
  },
  options: {
    responsive: true,
    // tainAspectRatio: false,
    lineTension: 1,
    scales: {
      xAxes: [{
        ticks: {
          // callback: function (value) {
          //   return value + " %";
          // },
          min: 0,
          // max: 100,
          beginAtZero: true
        },
        scaleLabel: {
          display: true,
          fontSize: 12,

        }
      }]
    }

  }
}

export default planetChartData;
